import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
  NavDropdown,
  Image,
  Placeholder,
  Offcanvas,
  Button,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faBasketShopping,
  faEnvelope,
  faGaugeHigh,
  faRightFromBracket,
  faShop,
  faSliders,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

import { useAuth } from "../../contexts/AuthContext";
import Utils from "../../configs/Utils";

import "./style.scss";

const PageHeader = () => {
  // Define states
  const { currentUser, isAuthenticated, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const logoutClickHandle = async (e) => {
    e.preventDefault();
    try {
      await logout();
      navigate("/");
    } catch (err) {
      console.log("request Auth error: ", err);
    }
  };

  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <>
      {isAuthenticated && (
        <>
          <header className="main-header">
            <nav className="navbar navbar-expand-lg navbar-light bg-white pt-2 pb-2">
              <div className="container">
                <Button
                  variant="light"
                  className="mobile-menu-btn d-block d-md-none"
                  onClick={handleShow}
                >
                  <FontAwesomeIcon icon={faBars} />
                </Button>
                <Link className="navbar-brand py-2" to="/">
                  <Image
                    src={Utils.getPublicImage("/assets/images/logo-main.png")}
                    width={165}
                  />
                </Link>
                <div className="d-none d-md-flex navbar-collapse offcanvas-collapse ms-4 align-items-center">
                  <ul className="navbar-nav me-auto mb-2 mb-lg-0 main-nav-links">
                    <li className="nav-item">
                      <Link
                        className={`nav-link${location.pathname === "/" ? " active" : ""}`}
                        to="/"
                      >
                        <FontAwesomeIcon icon={faGaugeHigh} className="me-2" />
                        Dashboard
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link${location.pathname.includes("/stores") ? " active" : ""}`}
                        to="/stores"
                      >
                        <FontAwesomeIcon icon={faShop} className="me-2" />
                        Stores
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link${location.pathname === "/orders" ? " active" : ""}`}
                        to="/orders"
                      >
                        <FontAwesomeIcon icon={faBasketShopping} className="me-2" />
                        Orders
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link${location.pathname.includes("/mail-templates") ? " active" : ""}`}
                        to="/mail-templates"
                      >
                        <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                        Email Templates
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="d-flex align-items-center">
                  <NavDropdown
                    id="account-dropdown"
                    className="account-dropdown ms-3"
                    align="end"
                    title={
                      <div className="d-flex align-items-center">
                        <Image
                          src={Utils.getPublicImage("/assets/images/profile-icon-new.png")}
                          roundedCircle
                          width={32}
                          className="me-2 shadow-sm border border-light"
                        />
                        <div className="d-none d-md-block text-start lh-1">
                          <strong className="d-block text-dark" style={{ fontSize: "14px" }}>
                            {currentUser?._id ? (
                              currentUser.fullName || currentUser.email
                            ) : (
                              <Placeholder animation="glow">
                                <Placeholder style={{ width: "80px", display: "inline-block" }} />
                              </Placeholder>
                            )}
                          </strong>
                          <small className="text-muted" style={{ fontSize: "12px" }}>
                            {currentUser?.admin ? "Administrator" : "Member"}
                          </small>
                        </div>
                      </div>
                    }
                  >
                    <NavDropdown.Item onClick={() => navigate("/profile")}>
                      <FontAwesomeIcon icon={faUser} className="me-2 text-muted" />
                      Profile
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => navigate("/workspace")}>
                      <FontAwesomeIcon icon={faUsers} className="me-2 text-muted" />
                      Workspace
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => navigate("/settings")}>
                      <FontAwesomeIcon icon={faSliders} className="me-2 text-muted" />
                      Settings
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#" onClick={logoutClickHandle} className="text-danger">
                      <FontAwesomeIcon icon={faRightFromBracket} className="me-2" />
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                </div>
              </div>
            </nav>
          </header>

          <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>MENU</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <ul className="nav nav-pills flex-column mb-auto">
                <li className="nav-item">
                  <Link
                    className={`nav-link${location.pathname === "/" ? " active" : ""}`}
                    to="/"
                    onClick={handleClose}
                  >
                    <FontAwesomeIcon
                      icon={faGaugeHigh}
                      size="xl"
                      className="bi pe-none me-2"
                    />
                    Dashboard
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link${location.pathname.includes("/stores") ? " active" : ""}`}
                    to="/stores"
                    onClick={handleClose}
                  >
                    <FontAwesomeIcon
                      icon={faShop}
                      size="xl"
                      className="bi pe-none me-2"
                    />
                    Stores
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link${location.pathname === "/orders" ? " active" : ""}`}
                    to="/orders"
                    onClick={handleClose}
                  >
                    <FontAwesomeIcon
                      icon={faBasketShopping}
                      size="xl"
                      className="bi pe-none me-2"
                    />
                    Orders
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className={`nav-link${location.pathname.includes("/mail-templates") ? " active" : ""}`}
                    to="/mail-templates"
                    onClick={handleClose}
                  >
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      size="xl"
                      className="bi pe-none me-2"
                    />
                    Email Templates
                  </Link>
                </li>
              </ul>
            </Offcanvas.Body>
          </Offcanvas>
        </>
      )}
    </>
  );
};

export default PageHeader;
